module.exports = __webpack_public_path__ + "static/FooterLogo.437784ac.svg";